import { Tooltip } from "@chakra-ui/react";
import React from "react";
import { cn } from "@/lib/utils";
import { SseStatus, useSseStore } from "../../../stores/sse.store";

const LABELS: Record<SseStatus, string> = {
	online: "Ansluten – realtidsuppdateringar aktiva",
	connecting: "Ansluter…",
	offline: "Frånkopplad – återansluter automatiskt",
};

/**
 * Small dot in the side menu that shows whether the live event stream to
 * api-gateway is open. Green = open, amber = connecting, grey = down.
 */
const ConnectionDot: React.FC<{ className?: string }> = ({ className }) => {
	const status = useSseStore((state) => state.status);

	return (
		<Tooltip label={LABELS[status]} placement="right" openDelay={300}>
			<span
				role="status"
				aria-label={LABELS[status]}
				data-status={status}
				className={cn("inline-flex h-2.5 w-2.5 items-center justify-center", className)}
			>
				<span
					className={cn(
						"block h-1.5 w-1.5 rounded-full transition-colors",
						status === "online" && "bg-success",
						status === "connecting" && "bg-warning animate-pulse",
						status === "offline" && "bg-neutral-500"
					)}
				/>
			</span>
		</Tooltip>
	);
};

export default ConnectionDot;
